import { render, staticRenderFns } from "./Pool.vue?vue&type=template&id=2081c358&scoped=true&"
import script from "./Pool.vue?vue&type=script&lang=ts&"
export * from "./Pool.vue?vue&type=script&lang=ts&"
import style0 from "./Pool.vue?vue&type=style&index=0&id=2081c358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081c358",
  null
  
)

export default component.exports